import {
  DropzoneContent
} from "./chunk-VHDOGGRV.mjs";
import {
  Loading
} from "./chunk-DTOUNUTO.mjs";

// src/views/Dropzone/Dropzone.tsx
import { Flex } from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var Dropzone = ({
  dropText,
  selectText,
  supportedFilesText,
  uploadText,
  loadingText,
  isLoading,
  isDropzoneActive,
  getInputProps,
  getRootProps,
  fileRejections,
  isInvalid,
  dataTestId
}) => {
  const isError = (fileRejections == null ? void 0 : fileRejections.length) > 0 || isInvalid;
  const getBorderColor = () => {
    if (isDropzoneActive) {
      return "primary.100";
    }
    if (isError) {
      return "danger.500";
    }
    return "greyscale.400";
  };
  return /* @__PURE__ */ jsxs(Flex, {
    ...getRootProps,
    direction: "column",
    alignItems: { base: "flex-start", md: "center" },
    justifyContent: "center",
    outline: "none",
    w: "100%",
    h: { base: "96px", md: "236px" },
    borderRadius: "md",
    border: isError ? "solid" : "dashed",
    borderWidth: "1px",
    borderColor: getBorderColor(),
    bg: isDropzoneActive ? "primary.100" : "greyscale.100",
    boxShadow: isDropzoneActive ? "0px 0px 0px 4px #DFEDFF" : "none",
    cursor: "pointer",
    _hover: { borderColor: isError ? "danger.800" : "primary.300" },
    _focus: { borderColor: isError ? "danger.800" : "primary.500" },
    children: [
      /* @__PURE__ */ jsx("input", {
        ...getInputProps,
        "data-testid": dataTestId || "documentUploader"
      }),
      isLoading ? /* @__PURE__ */ jsx(Loading, {
        label: loadingText
      }) : /* @__PURE__ */ jsx(DropzoneContent, {
        uploadText,
        selectText,
        dropText,
        supportedFilesText,
        isDropzoneActive
      })
    ]
  });
};

export {
  Dropzone
};
